<div class="wrap">
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol>
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><a (click)="this.returnToList()" style="cursor:pointer;">Customers</a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>Customer Details</span></li>
                    </ol>
                </div>
                <div class="profile-holder">
                    <div class="profile">
                        <div class="pfp">
                            <img src="../../../../assets/okito/images/avatar.png">
                        </div>
                        <div class="profile-info">
                            <h4>{{ this.detailViewed['name'] }}</h4>
                            <div class="tags">
                                <span class="stat-icon"
                                    *ngIf="this.detailViewed['isVerify']; else showNotVerified"><img
                                        src="../../../../assets/okito/images/badge/verified.svg">ACTIVE</span>
                                <ng-template #showNotVerified>
                                    <span class="stat-icon"><img
                                            src="../../../../assets/okito/images/badge/not-verified.svg">NOT
                                        VERIFIED</span>
                                </ng-template>
                            </div>
                        </div>
                    </div>

                    <div class="points" *ngIf="this.consumerTabs2['bookings'] || this.consumerTabs2['rewards'] ">
                        <div class="points-grp">
                            <small>Points Balance</small>
                            <h4>{{ this.detailViewed['currentPoints'] }}</h4>
                        </div>
                        <div class="points-grp">
                            <small>Used Points</small>
                            <h4>{{ this.detailViewed['usedPoints'] }}</h4>
                        </div>
                    </div>
                    <div class="profile-actions" *ngIf="this.consumerTabs2['info']">
                        <button class="btn btn-sm btn-default" style="margin-right: 1em;">Edit Customer</button>
                        <button class="btn btn-sm btn-default" (click)="this.returnToList()">Return to List</button>
                    </div>
                </div>
                <div class="list-tabs">
                    <ul>
                        <li [ngClass]="{'active': this.consumerTabs2['info']}"><a (click)="detailConsumerTabActive('info')" style="cursor: pointer;">Personal Information</a></li>
                        <li [ngClass]="{'active': this.consumerTabs2['bookings']}"><a (click)="detailConsumerTabActive('bookings')" style="cursor: pointer;">Booking History</a></li>
                        <li [ngClass]="{'active': this.consumerTabs2['rewards']}"><a (click)="detailConsumerTabActive('rewards')" style="cursor: pointer;">Rewards</a></li>
                    </ul>
                </div>
                <div class="panel" *ngIf="this.consumerTabs2['info']">
                    <h3>Account Information</h3>
                    <div class="panel-info">
                        <div class="panel-grp">
                            <div class="mb-2 row">
                                <label class="col-sm-2 col-form-label">Membership ID</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" disabled
                                        [(ngModel)]="this.detailViewed['membershipId']">
                                </div>
                            </div>
                        </div>
                        <div class="panel-grp">
                            <div class="mb-2 row">
                                <label class="col-sm-2 col-form-label">Email</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" disabled
                                        [(ngModel)]="this.detailViewed['email']">
                                </div>
                            </div>
                        </div>
                        <div class="panel-grp">
                            <div class="mb-2 row">
                                <label class="col-sm-2 col-form-label">Mobile</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" disabled
                                        [(ngModel)]="this.detailViewed['mobile']">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel" *ngIf="this.consumerTabs2['bookings']">
                    <div class="list-holder">
                        <select class="form-select" style="width:30%;margin-right:10px;" [(ngModel)]="this.selectedServiceType"
                            (ngModelChange)="onServiceTypeChange($event)">
                            <option value="express">OK! Express</option>
                            <option value="okride">OK! Ride</option>
                            <option value="mototaxi">OK! MotoTaxi</option>
                        </select>
                        <div class="tools">
                            <div class="search mg-right-auto">
                                <img src="../../../../assets/okito/images/icons/magnifying.svg">
                                <input (input)="searchDataBooking($event)" [(ngModel)]="this.searchKeywordBooking" type="text"
                                    class="text-search" placeholder="Search">
                            </div>
                            <div class="search mg-right-auto" style="width:58%; ">
                                <span style="font-weight:bold;margin-right:10px;margin-left:20px;">Sorting: </span>
                                <select class="form-select" style="width:30%;margin-right:10px;" [(ngModel)]="bookingSortBy"
                                    (ngModelChange)="onBookingSortChange()">
                                    <option value="dateCreated">Date Created</option>
                                    <option value="status">Status</option>
                                </select>
                                <div class="btn-group" role="group" aria-label="Sort by.." style="width:5%;">
                                    <button type="button" [ngClass]="{'active': bookingSortDirection === 'asc'}" class="btn btn-secondary"
                                        (click)="bookingSortDirection = 'asc'; onBookingSortChange()">Ascending</button>
                                    <button type="button" [ngClass]="{'active': bookingSortDirection === 'desc'}" class="btn btn-secondary"
                                        (click)="bookingSortDirection = 'desc'; onBookingSortChange()">Descending</button>
                                </div>
                            </div>
                            <div class="actions">
                                <button class="btn btn-sm btn-default">Download</button>
                            </div>
                        </div>
                        <div class="list table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Booking ID</th>
                                        <th>Rider</th>
                                        <th>Pick-up</th>
                                        <th>Drop-off</th>
                                        <th>Date</th>
                                        <th>Fee</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="booking_currentSelectedPageList.length != 0; else noRecordsBooking">
                                        <tr *ngFor="let booking of this.booking_currentSelectedPageList">
                                            <td>{{ (selectedServiceType == 'express') ? booking.bookingExpressId : booking.bookingRideId }}</td>
                                            <td *ngIf="booking.partner === null">---</td>
                                            <td *ngIf="booking.partner !== null">{{ booking.partner.firstName }} {{ booking.partner.middleName }} {{ booking.partner.lastName }}</td>
                                            <td>{{ booking.startFormattedAddress }}</td>
                                            <td>{{ booking.endFormattedAddress }}</td>
                                            <td>{{ booking.dateCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A' }}</td>
                                            <td>{{ booking.totalPrice | currency:'PHP' }}</td>
                                            <td>
                                                <span class="stat stat-canceled" *ngIf="booking.status === 'pending'">Pending</span>
                                                <span class="stat stat-ongoing" *ngIf="booking.status === 'accepted'">Accepted</span>
                                                <span class="stat stat-ongoing" *ngIf="booking.status === 'ongoing_pickup'">Ongoing - Pickup</span>
                                                <span class="stat stat-ongoing" *ngIf="booking.status === 'ongoing_destination'">Ongoing - Destination</span>
                                                <span class="stat stat-completed" *ngIf="booking.status === 'completed'">Completed</span>
                                                <span class="stat stat-canceled" *ngIf="booking.status === 'canceled'">Cancelled</span>
                                            </td>
                                            <td><a (click)="viewBookingDetails(booking, bookingDetail, selectedServiceType)" style="cursor: pointer;">View</a></td>
                                        </tr>
                                    </ng-container>
                                    <ng-template #noRecordsBooking>
                                        <tr>
                                            <td colspan="8" class="no-records-msg">
                                                <h6 class="ponds-contents-med-bold">No records found</h6>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
                        <div class="list-footer" *ngIf="this.bookingList.length != 0">
                            <div class="pager">
                                <button (click)="nextPrevBooking('prev')" [disabled]="this.disableActionBtnsBooking.prev"><img
                                        src="../../../../assets/okito/images/icons/prev.svg"></button>
                                <button (click)="nextPrevBooking('next')" [disabled]="this.disableActionBtnsBooking.next"><img
                                        src="../../../../assets/okito/images/icons/next.svg"></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel" *ngIf="this.consumerTabs2['rewards']">
                    <div class="cards">
                        <div class="row">
                            <div class="col-md">
                                <div class="card-item">
                                    <div class="card-content">
                                        <small>Okito Voucher</small>
                                        <h4>0</h4>
                                    </div>
                                    <img src="../../../../assets/okito/images/card-icons/points.svg">
                                </div>
                            </div>
                            <div class="col-md">
                                <div class="card-item">
                                    <div class="card-content">
                                        <small>Digital Voucher</small>
                                        <h4>0</h4>
                                    </div>
                                    <img src="../../../../assets/okito/images/card-icons/digital.svg">
                                </div>
                            </div>
                            <div class="col-md">
                                <div class="card-item">
                                    <div class="card-content">
                                        <small>Raffle Item</small>
                                        <h4>2</h4>
                                    </div>
                                    <img src="../../../../assets/okito/images/card-icons/raffle.svg">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="list-holder">
                        <div class="list">
                            <table>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Title</th>
                                        <th>Type</th>
                                        <th>Draw Date</th>
                                        <th>Number of Winners</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1231232</td>
                                        <td>Rewards 1</td>
                                        <td>Raffle Item</td>
                                        <td>June 22, 2024</td>
                                        <td>5</td>
                                        <td>
                                            <span class="stat stat-ongoing">Ongoing</span>
                                        </td>
                                        <td><a href="#" data-bs-toggle="offcanvas" data-bs-target="#reward-ongoing"
                                                aria-controls="offcanvasRight">View</a></td>
                                    </tr>
                                    <tr>
                                        <td>1231232</td>
                                        <td>Rewards 2</td>
                                        <td>Raffle Item</td>
                                        <td>June 20, 2024</td>
                                        <td>5</td>
                                        <td>
                                            <span class="stat stat-completed">Ended</span>
                                        </td>
                                        <td><a href="#" data-bs-toggle="offcanvas" data-bs-target="#reward-ended"
                                                aria-controls="offcanvasRight">View</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="list-footer">
                            <div class="pager">
                                <button class="pager-prev"><img src="../../../../assets/okito/images/icons/prev.svg"></button>
                                <button class="pager-next"><img src="../../../../assets/okito/images/icons/next.svg"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #bookingDetail let-offcanvas>
        <div class="offcanvas-header">
            <h5 id="offcanvasRightLabel">
                <small>{{ this.bookingdetailViewed['dateCreated'] | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A' }}</small>
                <small>Booking ID</small>
                {{ (selectedServiceType == 'express') ? this.bookingdetailViewed['bookingExpressId'] : this.bookingdetailViewed['bookingRideId'] }}
            </h5>
            <span class="stat stat-canceled" *ngIf="this.bookingdetailViewed['status'] === 'pending'">Pending</span>
            <span class="stat stat-ongoing" *ngIf="this.bookingdetailViewed['status'] === 'accepted'">Accepted</span>
            <span class="stat stat-ongoing" *ngIf="this.bookingdetailViewed['status'] === 'ongoing_pickup'">Ongoing - Pickup</span>
            <span class="stat stat-ongoing" *ngIf="this.bookingdetailViewed['status'] === 'ongoing_destination'">Ongoing - Destination</span>
            <span class="stat stat-completed" *ngIf="this.bookingdetailViewed['status'] === 'completed'">Completed</span>
            <span class="stat stat-canceled" *ngIf="this.bookingdetailViewed['status'] === 'canceled'">Cancelled</span>
            <button type="button" class="btn-close text-reset" (click)="offcanvas.dismiss('Cross click')"></button>
        </div>
        <div class="offcanvas-body">
            <div class="booking-holder">
                <google-map height="250px" width="370px" [center]="center" [zoom]="zoom" (mapClick)="moveMap($event)"
                    (mapMousemove)="move($event)">
                    <map-polyline [path]="polyLinePath" [options]="polyLineOptions" />
                </google-map>
                <div class="booking-rider-details">
                    <div class="pfp">
                        <img src="./../../../assets/okito/images/avatar.png">
                    </div>
                    <div class="rider-info" *ngIf="this.bookingdetailViewed['partner'] !== null">
                        {{ this.bookingdetailViewed['partner']['firstName'] }} {{ this.bookingdetailViewed['partner']['middleName'] }} {{ this.bookingdetailViewed['partner']['lastName'] }}<br>
                        <small>{{ this.bookingdetailViewed['vehicleCategory'] }} - {{ this.bookingdetailViewed['vehicleId'] }}</small>
                    </div>
                    <div class="rider-info" *ngIf="this.bookingdetailViewed['partner'] === null">
                        ---
                    </div>
                    <div class="rider-rating" *ngIf="this.bookingdetailViewed['partner'] !== null">
                        <img src="./../../../assets/okito/images/star.svg">
                        <h4 *ngIf="selectedServiceType === 'express' && this.bookingdetailViewed['rating'] === null">0.00</h4>
                        <h4 *ngIf="selectedServiceType === 'express' && this.bookingdetailViewed['rating'] !== null">{{ this.bookingdetailViewed['rating']['rate'] | number: '1.2-2' }}</h4>
                        <h4 *ngIf="selectedServiceType !== 'express' && this.bookingdetailViewed['partnerRating'] === null">0.00</h4>
                        <h4 *ngIf="selectedServiceType !== 'express' && this.bookingdetailViewed['partnerRating'] !== null">{{ this.bookingdetailViewed['partnerRating']['rate'] | number: '1.2-2' }}</h4>
                    </div>
                </div>
                <div class="booking-address">
                    <div class="booking-address-details">
                        <img src="./../../../assets/okito/images/pickup.svg">
                        <div class="sender-details">
                            <label>Pick-up Location</label>
                            <h4>{{ this.bookingdetailViewed['startFormattedAddress'] }}</h4>
                            <div class="sender">
                                <span>{{ this.bookingdetailViewed['senderName'] }}</span>
                                <span>{{ this.bookingdetailViewed['senderMobile'] }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="booking-address-details">
                        <img src="./../../../assets/okito/images/dropoff.svg">
                        <div class="sender-details">
                            <label>Drop-off Location</label>
                            <h4>{{ this.bookingdetailViewed['endFormattedAddress'] }}</h4>
                            <div class="sender">
                                <span>{{ this.bookingdetailViewed['receipientName'] }}</span>
                                <span>{{ this.bookingdetailViewed['receipientMobile'] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="booking-note">
                <label>Note to rider</label>
                <p>{{ this.bookingdetailViewed['notes'] }}</p>
            </div>
            <div class="booking-distance">
                <div class="fees-grp">
                    <div class="distance-label">
                        <img src="./../../../assets/okito/images/dropoff.svg">
                        <label>Distance</label>
                    </div>
                    <span>{{ (selectedServiceType == 'express') ? this.bookingdetailViewed['totalDistance'] : this.bookingdetailViewed['kmDistance'] }} km</span>
                </div>
            </div>
            <div class="pwdsc">
                <div class="pwdsc-id">
                    <img src="./../../../assets/okito/images/pwdsc.png">
                    <div class="pwdsc-info">
                        <label>Discount</label>
                        <h4>PWD/SC/Student Card</h4>
                    </div>
                </div>
            </div>
            <div class="booking-fees">
                <div class="fees-grp">
                    <label>Delivery Fee</label>
                    <span>{{ this.bookingdetailViewed['farePrice'] | currency:'PHP' }}</span>
                </div>
                <div class="fees-grp">
                    <label>Discount</label>
                    <span class="discount">-{{ this.bookingdetailViewed['discountPrice'] | currency:'PHP' }}</span>
                </div>
                <div class="total-fees">
                    <label>Total Delivery Fee</label>
                    <div class="total">
                    <img src="./../../../assets/okito/images/cash.svg">
                        <span>{{ this.bookingdetailViewed['totalPrice'] | currency:'PHP' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
